export default __webpack_public_path__ + "static/media/baseline-info-24px.f07ffc00.svg";